var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.91023C8.82838 7.91023 9.49992 8.58187 9.5 9.41023C9.5 10.2387 8.82843 10.9102 8 10.9102C7.17157 10.9102 6.5 10.2387 6.5 9.41023C6.50008 8.58187 7.17162 7.91023 8 7.91023ZM8 8.91023C7.72391 8.91023 7.50008 9.13416 7.5 9.41023C7.5 9.68637 7.72386 9.91023 8 9.91023C8.27614 9.91023 8.5 9.68637 8.5 9.41023C8.49992 9.13416 8.27609 8.91023 8 8.91023Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3833 2.7198C9.86104 2.44922 10.4676 2.61444 10.7422 3.08991L11.5366 4.46589C11.9911 4.44967 12.4145 4.74655 12.5376 5.20613L12.8604 6.41023H13L13.0513 6.41267C13.3033 6.43833 13.4999 6.65146 13.5 6.91023V11.9102C13.5 12.1691 13.3033 12.3821 13.0513 12.4078L13 12.4102H3C2.74116 12.4102 2.52811 12.2136 2.50244 11.9615L2.5 11.9102V6.91023C2.50006 6.71957 2.60668 6.5536 2.76367 6.46931L9.3833 2.7198ZM4.49316 7.52009C4.43849 8.02071 4.01518 8.41023 3.5 8.41023V10.4102C4.05223 10.4102 4.49992 10.858 4.5 11.4102H11.5C11.5001 10.858 11.9478 10.4102 12.5 10.4102V8.41023C11.9477 8.41023 11.5 7.96251 11.5 7.41023H4.87207L4.49316 7.52009ZM8.31592 6.41023H11.8252L11.5718 5.46491L8.31592 6.41023ZM5.07373 6.30964L10.5317 4.72517L9.87646 3.58991L5.07373 6.30964Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.5771d1d8a4abe05d9832a5c43d37e460.svg";
export { ForwardRef as ReactComponent };